import { Link } from 'react-router-dom';
import AnimatedCounter from '../../components/feature/AnimatedCounter';
import { useSEO, generateOrganizationSchema, generateLocalBusinessSchema, generateWebSiteSchema } from '../../utils/seo';

export default function Home() {
  // SEO Configuration
  useSEO({
    title: 'Osmaniye İlkyardım Eğitimi | ASSA İş Eğitimleri Akademisi - Sağlık Bakanlığı Onaylı',
    description: 'Osmaniye ilkyardım eğitimi ve iş güvenliği sertifikası. IRATA LEVEL 3 yüksekte çalışma, yangın güvenliği, hijyen eğitimi. Sağlık Bakanlığı onaylı profesyonel eğitim merkezi. ☎ 0850 346 2772',
    keywords: 'Osmaniye ilkyardım eğitimi, ilkyardım sertifikası Osmaniye, iş güvenliği eğitimi Osmaniye, IRATA LEVEL 3 eğitim, yüksekte çalışma sertifikası, yangın güvenliği eğitimi, hijyen eğitimi, MYK belgelendirme, Sağlık Bakanlığı onaylı eğitim',
    canonical: '/',
    schema: {
      '@context': 'https://schema.org',
      '@graph': [
        generateWebSiteSchema(),
        generateOrganizationSchema(),
        generateLocalBusinessSchema()
      ]
    }
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-lg sticky top-0 z-50">
        <div className="container mx-auto px-6">
          <div className="flex justify-between items-center py-4">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/69983b9b992309f9f345f22b715baa7c/d976ad48ea6e824eb2b305836503c616.jfif" 
                alt="ASSA Logo" 
                className="h-12 w-auto"
              />
            </Link>
            <div className="hidden md:flex space-x-8">
              <Link to="/" className="text-blue-600 font-semibold cursor-pointer">Ana Sayfa</Link>
              <Link to="/egitimlerimiz" className="text-gray-700 hover:text-blue-600 cursor-pointer">Eğitimlerimiz</Link>
              <Link to="/hakkimizda" className="text-gray-700 hover:text-blue-600 cursor-pointer">Hakkımızda</Link>
              <Link to="/sss" className="text-gray-700 hover:text-blue-600 cursor-pointer">SSS</Link>
              <Link to="/iletisim" className="text-gray-700 hover:text-blue-600 cursor-pointer">İletişim</Link>
            </div>
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <section 
        className="relative h-screen bg-cover bg-center bg-no-repeat flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(37, 99, 235, 0.8), rgba(37, 99, 235, 0.6)), url('https://public.readdy.ai/ai/img_res/461674efac224775400c771c8e5a8f4d.jpg')`
        }}
      >
        <div className="container mx-auto px-6 text-white">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Sağlık Bakanlığı Onaylı İlkyardım Eğitimleri
            </h1>
            <p className="text-xl md:text-2xl mb-8 leading-relaxed">
              Profesyonel eğitmenlerimiz eşliğinde, yasal yönetmeliklere uygun ilkyardım sertifikası alın. Hayat kurtarmayı öğrenin.
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <Link 
                to="/egitimlerimiz"
                className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Eğitimlerimizi İncele
              </Link>
              <Link 
                to="/iletisim"
                className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
              >
                Bilgi Al
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Certifications Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Sağlık Bakanlığı Onaylı Eğitimler</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Türkiye'deki ilkyardım eğitim yönetmeliğine tam uyumlu, geçerli sertifikalarla mezun olun
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-government-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Resmi Onay</h3>
              <p className="text-gray-600 leading-relaxed">
                Sağlık Bakanlığı tarafından onaylı müfredat ve eğitim programları
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-award-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Geçerli Sertifika</h3>
              <p className="text-gray-600 leading-relaxed">
                Tüm kamu ve özel sektörde geçerli ilkyardım sertifikası
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg text-center">
              <div className="w-16 h-16 bg-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className="ri-user-star-line text-2xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Uzman Eğitmenler</h3>
              <p className="text-gray-600 leading-relaxed">
                Deneyimli sağlık profesyonelleri tarafından verilen eğitimler
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Programs Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Eğitim Programlarımız</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Geniş eğitim yelpazimiz ile iş güvenliği, sağlık ve mesleki gelişim alanlarında uzmanlaşın
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Temel İlkyardım */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-6 rounded-xl border border-blue-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Professional%20first%20aid%20training%20with%20CPR%20mannequin%2C%20medical%20instructor%20demonstrating%20emergency%20techniques%2C%20bright%20medical%20classroom%20setting%20with%20clean%20white%20background&width=300&height=200&seq=basic-firstaid&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-blue-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-heart-pulse-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Temel İlkyardım Eğitimi</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                16 saatlik kapsamlı temel ilkyardım eğitimi. CPR, yaralanmalar ve acil durumlar.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>
            
            {/* Güncelleme Eğitimi */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 p-6 rounded-xl border border-green-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=First%20aid%20refresher%20training%20course%20with%20experienced%20professionals%2C%20updated%20medical%20techniques%20demonstration%2C%20modern%20healthcare%20education%20facility&width=300&height=200&seq=refresh-course&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-green-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-refresh-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Güncelleme Eğitimi</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                8 saatlik yenileme eğitimi. Mevcut sertifikanızı güncel tekniklerle yenileyin.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>
            
            {/* Eğitici Eğitimi */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 p-6 rounded-xl border border-purple-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Advanced%20first%20aid%20instructor%20training%20session%2C%20professional%20medical%20educator%20teaching%20advanced%20techniques%2C%20instructor%20certification%20program%20in%20modern%20medical%20facility&width=300&height=200&seq=instructor-training&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-purple-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-user-star-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">İlk Yardım Eğitici</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                40 saatlik eğitici sertifikası. İlkyardım eğitmeni olmak için gerekli yetkinlikler.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>

            {/* Yüksekte Çalışma */}
            <div className="bg-gradient-to-br from-orange-50 to-orange-100 p-6 rounded-xl border border-orange-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Height%20safety%20training%20with%20professional%20safety%20equipment%2C%20workers%20learning%20to%20use%20safety%20harnesses%20and%20ropes%2C%20industrial%20safety%20education%20with%20safety%20gear%20demonstration&width=300&height=200&seq=height-safety&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-orange-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-building-2-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Yüksekte Çalışma</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                16 saatlik yüksekte çalışma güvenliği. Emniyet kemeri, ip erişim teknikleri.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-orange-600 hover:bg-orange-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>

            {/* Yangın Eğitimi */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 p-6 rounded-xl border border-red-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Fire%20safety%20training%20with%20fire%20extinguishers%2C%20professional%20firefighting%20equipment%20demonstration%2C%20emergency%20response%20training%20in%20industrial%20safety%20facility&width=300&height=200&seq=fire-safety&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-fire-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Yangın Eğitimi</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                8 saatlik yangın güvenliği eğitimi. Yangın söndürme, tahliye prosedürleri.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>

            {/* Hijyen Eğitimi */}
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 p-6 rounded-xl border border-teal-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Professional%20hygiene%20training%20in%20clean%20medical%20environment%2C%20healthcare%20workers%20learning%20proper%20sanitation%20techniques%2C%20food%20safety%20and%20workplace%20hygiene%20education&width=300&height=200&seq=hygiene-training&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-hand-sanitizer-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Hijyen Eğitimi</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                6 saatlik hijyen eğitimi. Gıda güvenliği, kişisel hijyen ve temizlik standartları.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-teal-600 hover:bg-teal-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>

            {/* Mesleki Eğitimler */}
            <div className="bg-gradient-to-br from-indigo-50 to-indigo-100 p-6 rounded-xl border border-indigo-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Professional%20vocational%20training%20classroom%20with%20modern%20equipment%2C%20skilled%20workers%20learning%20technical%20skills%2C%20industrial%20education%20and%20certification%20programs&width=300&height=200&seq=vocational-training&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-indigo-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-tools-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">Mesleki Eğitimler</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                Sektörel mesleki yetkinlik eğitimleri. İş güvenliği uzmanı, teknik eğitimler.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>

            {/* MYK Danışmanlığı */}
            <div className="bg-gradient-to-br from-pink-50 to-pink-100 p-6 rounded-xl border border-pink-200 hover:shadow-lg transition-shadow">
              <div 
                className="h-32 bg-cover bg-center rounded-lg mb-4"
                style={{
                  backgroundImage: "url('https://readdy.ai/api/search-image?query=Professional%20business%20consulting%20meeting%2C%20MYK%20certification%20consultancy%20service%2C%20modern%20office%20environment%20with%20business%20professionals%20discussing%20qualifications&width=300&height=200&seq=myk-consulting&orientation=landscape')"
                }}
              ></div>
              <div className="w-12 h-12 bg-pink-600 rounded-full flex items-center justify-center mb-4">
                <i className="ri-file-shield-line text-xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-3">MYK Danışmanlığı</h3>
              <p className="text-gray-700 mb-4 text-sm leading-relaxed">
                Mesleki Yeterlilik Kurumu süreçleri. Belgelendirme ve yetkinlik danışmanlığı.
              </p>
              <div className="text-center">
                <Link 
                  to="/iletisim"
                  className="bg-pink-600 hover:bg-pink-700 text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
                >
                  Bilgi Al
                </Link>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-12">
            <Link 
              to="/egitimlerimiz"
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer inline-block"
            >
              Tüm Eğitimleri Gör
            </Link>
          </div>
        </div>
      </section>

      {/* Statistics Section */}
      <section className="py-20 bg-blue-600 text-white">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={2500} suffix="+" />
              </div>
              <div className="text-xl">Mezun Kursiyerimiz</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={150} suffix="+" />
              </div>
              <div className="text-xl">Kurumsal Firma</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={8} />
              </div>
              <div className="text-xl">Yıllık Deneyim</div>
            </div>
            <div>
              <div className="text-5xl font-bold mb-2">
                <AnimatedCounter end={98} suffix="%" />
              </div>
              <div className="text-xl">Başarı Oranı</div>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-800 mb-6">Referanslarımız</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Kurumsal firmalar ve bireysel katılımcılarımızın deneyimleri
            </p>
          </div>
          
          <div className="grid md:grid-cols-3 gap-8">
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20business%20woman%20smiling%20confidently%20in%20modern%20office%20environment%2C%20wearing%20business%20attire%2C%20clean%20corporate%20headshot%20style%2C%20professional%20lighting%2C%20business%20executive%20portrait&width=80&height=80&seq=testimonial-1&orientation=squarish"
                  alt="Ayşe Demir"
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-800">Ayşe Demir</h4>
                  <p className="text-gray-600">İK Müdürü - TechCorp</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed">
                "Çalışanlarımız için aldığımız ilkyardım eğitimi çok kaliteli ve profesyoneldi. Eğitmenler son derece deneyimli ve sabırlıydı."
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Young%20university%20student%20male%20smiling%20warmly%2C%20casual%20but%20neat%20appearance%20in%20educational%20setting%2C%20friendly%20and%20approachable%20demeanor%2C%20natural%20lighting%2C%20student%20portrait&width=80&height=80&seq=testimonial-2&orientation=squarish"
                  alt="Mehmet Kaya"
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-800">Mehmet Kaya</h4>
                  <p className="text-gray-600">Üniversite Öğrencisi</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed">
                "Uygulamalı eğitim sayesinde ilkyardım tekniklerini gerçekten öğrendim. Sertifikam tüm iş başvurularımda kabul gördü."
              </p>
            </div>
            
            <div className="bg-white p-8 rounded-xl shadow-lg">
              <div className="flex items-center mb-6">
                <img 
                  src="https://readdy.ai/api/search-image?query=Middle-aged%20healthcare%20professional%20woman%20with%20kind%20expression%2C%20medical%20professional%20attire%2C%20confident%20and%20caring%20demeanor%20in%20healthcare%20setting%2C%20professional%20medical%20portrait&width=80&height=80&seq=testimonial-3&orientation=squarish"
                  alt="Dr. Fatma Özkan"
                  className="w-16 h-16 rounded-full object-cover object-top mr-4"
                />
                <div>
                  <h4 className="font-bold text-gray-800">Dr. Fatma Özkan</h4>
                  <p className="text-gray-600">Aile Hekimi</p>
                </div>
              </div>
              <p className="text-gray-700 leading-relaxed">
                "Bilgilerimi tazelemek için katıldığım yenileme eğitimi çok faydalıydı. Güncel müfredat ve uygulamalar mükemmeldi."
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-blue-600 to-blue-800 text-white">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold mb-6">Hayat Kurtarmayı Öğrenmeye Hazır mısınız?</h2>
          <p className="text-xl mb-8 max-w-3xl mx-auto leading-relaxed">
            Sağlık Bakanlığı onaylı ilkyardım eğitimlerimize katılın ve profesyonel sertifikanızı alın. 
            Acil durumlarda hayat kurtarabilecek bilgi ve becerileri edinin.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/iletisim"
              className="bg-red-600 hover:bg-red-700 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Hemen Kayıt Ol
            </Link>
            <Link 
              to="/sss"
              className="bg-transparent border-2 border-white hover:bg-white hover:text-blue-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
            >
              Soru & Cevaplar
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-16">
        <div className="container mx-auto px-6">
          <div className="grid md:grid-cols-4 gap-8">
            <div>
              <p className="text-gray-300 leading-relaxed mb-6">
                Sağlık Bakanlığı onaylı ilkyardım eğitimleri ile hayat kurtarmayı öğrenin.
              </p>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Hızlı Linkler</h4>
              <ul className="space-y-3">
                <li>
                  <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">
                    Ana Sayfa
                  </Link>
                </li>
                <li>
                  <Link to="/egitimlerimiz" className="text-gray-300 hover:text-white cursor-pointer">
                    Eğitimlerimiz
                  </Link>
                </li>
                <li>
                  <Link to="/hakkimizda" className="text-gray-300 hover:text-white cursor-pointer">
                    Hakkımızda
                  </Link>
                </li>
                <li>
                  <Link to="/iletisim" className="text-gray-300 hover:text-white cursor-pointer">
                    İletişim
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">Eğitimler</h4>
              <ul className="space-y-3">
                <li>
                  <span className="text-gray-300">İSG Temel Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">Yüksekte Çalışma</span>
                </li>
                <li>
                  <span className="text-gray-300">Yangın Eğitimi</span>
                </li>
                <li>
                  <span className="text-gray-300">İlkyardım Eğitimi</span>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-6">İletişim</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-phone-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">0850 346 2772</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-line text-blue-400 mr-3"></i>
                  <span className="text-gray-300">info@assaakademi.com.tr</span>
                </div>
                <div className="flex items-start">
                  <i className="ri-map-pin-line text-blue-400 mr-3 mt-1"></i>
                  <span className="text-gray-300">Adnan Menderes, Emniyet Cd. 28/B, 80010 Osmaniye Merkez/Osmaniye</span>
                </div>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 pt-8 mt-12">
            <div className="flex flex-col md:flex-row justify-between items-center">
              <p className="text-gray-400 mb-4 md:mb-0">
                © 2024 Assa İş Eğitimleri Akademisi. Tüm hakları saklıdır.
              </p>
            </div>
          </div>
        </div>
      </footer>

      {/* WhatsApp Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="https://wa.me/+905324196401"
          target="_blank"
          rel="noopener noreferrer"
          className="bg-green-500 hover:bg-green-600 text-white w-16 h-16 rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300 animate-pulse cursor-pointer"
          title="WhatsApp ile iletişime geç"
        >
          <i className="ri-whatsapp-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}
